module.exports = __webpack_public_path__ + "img/35_fineStaff_zc.49c604d6.png";